<template>
    <div v-can:read-tab="'echanges_clients'">
        <div class="h2">
            Listing des échanges clients
        </div>
        <hr>

        <div class="clearfix" />

        <form
            class="mt-3 py-4 shadow px-3"
            @submit.prevent="search"
        >
            <div class="form-row">
                <div class="h4 col-5">
                    Recherche sur les échanges clients
                </div>

                <div
                    v-if="optionsRecherchesSauvegardeesEchange.length"
                    class="col-2"
                    :class="{'offset-5': !$store.getters.can('exec-action', 'recherche.add'), 'offset-3': $store.getters.can('exec-action', 'recherche.add')}"
                >
                    <base-select
                        v-model="rechercheSelectionnee"
                        :options="optionsRecherchesSauvegardeesEchange"
                    >
                        Recherches sauvegardées
                    </base-select>
                </div>
                <div
                    v-if="!rechercheSelectionnee"
                    v-can:exec-action="'recherche.add'"
                    class="col-2"
                    :class="{'offset-5': !optionsRecherchesSauvegardeesEchange.length}"
                >
                    <a
                        class="text-white btn btn-success mt-3 mb-3 px-4 float-right"
                        @click="showModalEditSearch = true"
                    >
                        Sauvegarder la recherche
                    </a>
                </div>
                <div
                    v-if="rechercheSelectionnee"
                    v-can:exec-action="'recherche.remove'"
                    class="col-2"
                >
                    <a
                        class="text-white btn btn-danger mb-3 mt-3 px-4 float-right"
                        @click="removeSearch(rechercheSelectionnee)"
                    >
                        Supprimer cette recherche
                    </a>
                </div>
            </div>

            <div class="form-row mt-4">
                <base-input
                    v-model="params.cegid"
                    class="col-2"
                >
                    Dossier (CEGID)
                </base-input>

                <base-input
                    v-model="params.client"
                    class="col-2"
                >
                    Client
                </base-input>

                <base-input
                    v-model="params.exercice"
                    class="col-2"
                >
                    Exercice
                </base-input>

                <base-select
                    v-model="params.lieuxCollectes"
                    :options="addEmptyOption(optionsLieuxCollectes)"
                    multiple
                    class="col-2"
                >
                    Lieu de collecte
                </base-select>

                <base-select
                    v-model="params.lieuxProductions"
                    :options="addEmptyOption(optionsLieuxProductions)"
                    multiple
                    class="col-2"
                >
                    Lieu de production
                </base-select>

                <base-select
                    v-model="params.cabinets"
                    :options="optionsCabinets"
                    multiple
                    class="col-2"
                >
                    Cabinet
                </base-select>
            </div>

            <div class="form-row">
                <base-select
                    v-model="params.typeMissions"
                    :options="optionsTypeMissions"
                    class="col-2"
                    multiple
                >
                    Type de mission
                </base-select>

                <base-select
                    v-model="params.equipes"
                    :options="optionsEquipes"
                    class="col-2"
                    multiple
                >
                    Équipe
                </base-select>

                <base-select
                    v-model="params.created_by_role"
                    :options="optionsRoles"
                    class="col-2"
                    multiple
                >
                    Rôle créateur
                </base-select>

                <base-select
                    v-model="params.created_by_id"
                    :options="optionsUsers"
                    class="col-2"
                    multiple
                >
                    Créé par
                </base-select>

                <base-select
                    v-model="params.updated_by_id"
                    :options="optionsUsers"
                    class="col-2"
                    multiple
                >
                    Modifié par
                </base-select>

                <base-select
                    v-model="params.attributed_to_id"
                    :options="addEmptyOption(optionsUsers)"
                    class="col-2"
                    multiple
                >
                    Attribué à
                </base-select>

                <base-select
                    v-model="params.sujets"
                    :options="optionsAllSujets"
                    class="col-4"
                    multiple
                >
                    Sujet
                </base-select>

                <base-select
                    v-model="params.statut_echange"
                    :options="optionsStatutEchange"
                    class="col-2"
                    multiple
                >
                    Statut échange
                </base-select>

                <base-select
                    v-model="params.statut_question"
                    :options="optionsStatutQuestion"
                    class="col-2"
                    multiple
                >
                    Statut de question
                </base-select>

                <base-select
                    v-model="params.categorie_echange"
                    :options="optionsCategorieEchange"
                    class="col-2"
                    multiple
                >
                    Catégorie
                </base-select>

                <base-select
                    v-model="params.provenance_echange"
                    :options="optionsProvenanceEchange"
                    class="col-2"
                    multiple
                >
                    Provenance
                </base-select>
            </div>

            <div class="form-row">
                <base-select
                    v-model="params.is_prioritaire"
                    :options="optionsOuiNon"
                    class="col-2"
                >
                    Prioritaire
                </base-select>

                <base-input
                    v-model="params.created_at_min"
                    type="date"
                    class="col-2"
                >
                    Création de l'échange après le
                </base-input>

                <base-input
                    v-model="params.created_at_max"
                    type="date"
                    class="col-2"
                >
                    Création de l'échange avant le
                </base-input>

                <base-input
                    v-model="params.updated_at_min"
                    type="date"
                    class="col-2"
                >
                    Modification de l'échange après le
                </base-input>

                <base-input
                    v-model="params.updated_at_max"
                    type="date"
                    class="col-2"
                >
                    Modification de l'échange avant le
                </base-input>
            </div>

            <button
                type="submit"
                class="btn btn-success float-right mt-3 px-4"
            >
                Rechercher
            </button>

            <button
                class="btn btn-info float-right mt-3 px-4 mr-2"
                @click.prevent="reinit"
            >
                Réinitialiser
            </button>
            <span class="clearfix" />
        </form>

        <base-table
            :items="items"
            :meta="meta"
            :params="exParams"
            :loading="loading"
            :head="head"
            name="échange client"
            no-export
            class="mt-5"
            @orderBy="orderBy"
            @change-page="goToPage"
            @paginate="paginate"
        >
            <div
                slot="extra-buttons"
                class="d-inline-block"
            >
                <button
                    v-can:exec-action="'dossier.modification_massive'"
                    class="btn btn-secondary btn-sm ml-2"
                    :title="'Ce bouton permet de modifier des champs en série.'"
                    :disabled="!params.exercice"
                    @click="showModalMassModification = true"
                >
                    Modifier les champs en série
                </button>
            </div>

            <tr
                v-for="echange of items"
                :key="echange.id"
            >
                <td>
                    <router-link
                        :to="{name: 'dossier', params: {id: echange.dossier_id}}"
                        title="Dossier"
                    >
                        {{ echange.dossier.cegid }}
                    </router-link>
                </td>

                <td>
                    <template v-if="echange.dossier.client.is_indivision">
                        {{ echange.dossier.client.type_indivision }} {{ echange.dossier.client.libelle_indivision }}
                    </template>

                    <template v-else>
                        {{ echange.dossier.client.nom }} {{ echange.dossier.client.prenom }}
                    </template>
                </td>

                <td>
                    <div
                        v-for="question in echange.echange_questions"
                        :key="question.id"
                    >
                        {{ getSujet(question.sujet.parent_id).libelle }} - {{ question.sujet.libelle }}
                    </div>
                </td>

                <td>
                    <div
                        v-for="question in echange.echange_questions"
                        :key="question.id"
                    >
                        {{ getLabel(optionsStatutQuestion, question.statut_question) }}
                    </div>
                </td>

                <td>
                    <div
                        v-for="question in echange.echange_questions"
                        :key="question.id"
                    >
                        {{ question.is_prioritaire | yesNo }}
                    </div>
                </td>

                <td class="no-wrap">
                    <b>Catégorie:</b>
                    <br>
                    {{ getLabel(optionsCategorieEchange, echange.categorie_echange) }}
                    <br>
                    <b>Provenance:</b>
                    <br>
                    {{ getLabel(optionsProvenanceEchange, echange.provenance_echange) }}
                </td>

                <td>
                    {{ getLabel(optionsStatutEchange, echange.statut_echange) }}
                </td>

                <td>
                    {{ echange.created_at | frenchDateTime }}
                    <span v-if="echange.created_by">
                        <br>
                        {{ echange.created_by.nom + ' ' + echange.created_by.prenom }}
                    </span>
                </td>

                <td>
                    {{ echange.updated_at | frenchDateTime }}
                    <span v-if="echange.updated_by">
                        <br>
                        {{ echange.updated_by.nom + ' ' + echange.updated_by.prenom }}
                    </span>
                </td>

                <td>
                    {{ echange.attributed_to ? echange.attributed_to.nom + ' ' + echange.attributed_to.prenom : '' }}
                </td>

                <td>
                    {{ echange.dossier.cabinet !== null ? echange.dossier.cabinet.nom : '' }}
                </td>

                <td class="text-center">
                    <router-link
                        :to="{name: 'dossierEchangesClient', params: {id: echange.dossier_id}}"
                        class="btn btn-primary btn-sm"
                        title="Voir le détail de l'échange"
                    >
                        <i class="fa fa-glasses" />
                    </router-link>
                </td>
            </tr>
        </base-table>

        <SearchEditModal
            v-if="showModalEditSearch"
            :filters="params"
            :emplacement="'Echanges'"
            @close="showModalEditSearch = null"
            @reload="reloadRechercheSelectionnee"
        />

        <SelectionMassModificationModal
            v-if="showModalMassModification"
            :additional-params="exParams"
            emplacement="echange"
            @close="search(); showModalMassModification = false"
        />
    </div>
</template>

<script>
    import TableNavigate from "../../mixins/TableNavigate"
    import BaseTable from "../templates/BaseTable"
    import BaseInput from "../templates/BaseInput"
    import BaseSelect from "../templates/BaseSelect"
    import SearchEditModal from "../modals/SearchEditModal"
    import SelectionMassModificationModal from "../modals/SelectionMassModificationModal"
    import {mapGetters} from "vuex"

    export default {
        name: "EchangesClientsList",

        components: {BaseSelect, BaseInput, BaseTable, SearchEditModal, SelectionMassModificationModal},

        mixins: [TableNavigate],

        url: '/api/echange-clients',

        data: function () {
            return {
                params: this.initParams(),
                showModalEditSearch: null,
                showModalMassModification: false,
                rechercheSelectionnee: 0,
                head: {
                    cegid: 'Dossier',
                    client: 'Client',
                    sujet: 'Sujets de questions',
                    statut_question: 'Statuts de questions',
                    is_prioritaire: 'Prioritaire',
                    categorie_echange: 'Origine',
                    statut_echange: 'Statut d\'échange',
                    created_at: 'Création de l\'échange',
                    updated_at: 'Dernière modification',
                    attributedTo: 'Attribué à',
                    cabinet_id: 'Cabinet',
                },
                optionsOuiNon: [
                    {value: '', label: 'Tous'},
                    {value: 1, label: 'Oui'},
                    {value: 0, label: 'Non'},
                ],
            }
        },

        computed: {
            ...mapGetters([
                'optionsCategorieEchange',
                'optionsCabinets',
                'optionsProvenanceEchange',
                'optionsStatutQuestion',
                'optionsStatutEchange',
                'optionsSousSujetsFromSujet',
                'optionsAllSujets',
                'optionsSujets',
                'optionsUsers',
                'optionsRoles',
                'optionsTypeMissions',
                'optionsLieuxCollectes',
                'optionsLieuxProductions',
                'optionsRecherchesSauvegardeesEchange',
                'getRecherchesSauvegardees',
                'optionsEquipes',
            ]),
        },

        watch: {
            params: {
                // This will let Vue know to look inside the array
                deep: true,

                // We have to move our method to a handler field
                handler() {
                    this.$router.replace(_.omit(this.$route.query, 'recherche'))

                    if (!this.changeSearch) {
                        this.rechercheSelectionnee = null
                    }
                    this.changeSearch = false
                    this.updateRechercheSelectionnee()
                }
            },

            'rechercheSelectionnee': function (value) {
                if (!value) {
                    return
                }
                const filters = this.getRecherchesSauvegardees.filter(filter => filter.id === value)

                if (filters.length >= 1) {
                    this.changeSearch = true
                    this.params = JSON.parse(filters[0].filtres)
                    this.search()
                }
            },
        },

        mounted: function () {
            this.$store.dispatch('resetRecherchesSauvegardees').then(
                () => this.setRechercheSelectionnee()
            )
        },

        methods: {
            /**
             * Réinitialise les paramètres
             */
            reinit: function () {
                this.params = this.initParams()
            },

            initParams: function () {
                return {
                    paginate: 15,
                    exercice: moment().subtract(5, 'months').year(),
                    statut_echange: [10,20],
                }
            },

            getSujet: function (sujet_id) {
                return this.$store.state.echangeSujets.sujets
                    .find(sujet => sujet.id === sujet_id)
            },

            getLabel: function (options, value) {
                return options.find((option) => option.value.toString() === value.toString()).label
            },

            /**
             * Ajout une option vide
             * @param options Array
             * @return Array
             */
            addEmptyOption: function (options) {
                return [{value: null, label: 'Non renseigné'}].concat(options)
            },

            search: function () {
                const params = JSON.parse(JSON.stringify(this.params))
                if (params.sujets && params.sujets.length) {
                    params.sujets.forEach((sujetId) => {
                        this.$store.state.echangeSujets.sujets
                            .filter(sujet => sujet.parent_id === sujetId)
                            .forEach(sujet => params.sujets.push(sujet.id))
                    })
                }

                return this.get({ params })
            },

            setRechercheSelectionnee: function() {
                this.rechercheSelectionnee = parseInt(this.$router.currentRoute.query.recherche || 0)
            },

            reloadRechercheSelectionnee: function() {
                this.$store.dispatch('resetRecherchesSauvegardees', this.updateRechercheSelectionnee)
            },

            updateRechercheSelectionnee: function() {
                this.getRecherchesSauvegardees.forEach((rechercheSauvegardee) => {
                    if (_.isEqual(JSON.parse(rechercheSauvegardee.filtres), this.params)) {
                        this.rechercheSelectionnee = rechercheSauvegardee.id
                    }
                })
            },

            removeSearch: function (rechercheSelectionnee) {
                this.$confirm('Êtes-vous certain de vouloir supprimer cette recherche ?').then(() => {
                    axios.delete(`/api/recherches-sauvegardees/${rechercheSelectionnee}`)
                        .then(() => {
                            this.$notify('success', 'La recherche a bien été supprimé.')
                            this.rechercheSelectionnee = null
                            this.$store.dispatch('resetRecherchesSauvegardees')
                        })
                        .catch(() => this.$notify('danger', 'Une erreur est survenue lors de la suppression.'))
                })
            },
        }
    }
</script>
